<template>
  <section>
    <el-form :inline="true" :model="dataForm" ref="lineForm">
      <el-form-item label="组织架构">
        <TenantCustomersSelectVue v-model="dataForm.DepartmentId" style="width: 220px"></TenantCustomersSelectVue>
      </el-form-item>
      <el-form-item label="客户名称:" prop="CompanyName">
        <el-input v-model="dataForm.CompanyName" placeholder="请输入客户公司名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="主叫:" prop="Caller">
        <el-input type="textarea" v-model="dataForm.Caller" placeholder="请输入主叫号码" clearable rows="1"></el-input>
      </el-form-item>
      <el-form-item label="被叫:" prop="Callee">
        <el-input type="textarea" v-model="dataForm.Callee" placeholder="请输入被叫号码" clearable rows="1"></el-input>
      </el-form-item>
      <el-form-item label="商户ID:">
        <el-input v-model="dataForm.MchId" placeholder="请输入商户ID"></el-input>
      </el-form-item>
      <el-form-item label="日期:">
        <el-date-picker v-model="dataForm.CreationTime" type="date" placeholder="选择日期" :clearable="false"
          :editable="false" @keydown.enter.native.stop @keydown.native.prevent :default-value="new Date()">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="() => {
      page = 1;
      handleGetDataList();
    }" type="primary" v-permission="['/Card/FilterLog/Search']">查询</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table :data="dataList" v-loading="dataListLoading" ref="table" class="custom-tbl" style="width: 100%">
      <el-table-column align="center" prop="Caller" label="主叫" wdith="200"></el-table-column>
      <el-table-column align="center" prop="Callee" label="被叫" wdith="200"></el-table-column>
      <el-table-column align="center" prop="DepartmentName" label="组织架构"></el-table-column>
      <el-table-column align="center" prop="CompanyName" label="客户名称"></el-table-column>
      <el-table-column align="center" prop="MchId" label="商户ID"></el-table-column>
      <el-table-column align="center" prop="Result" label="结果">
        <template slot-scope="scope">
          <span :style="{ color: scope.row.Result == 0 ? 'green' : 'gray' }">
            {{ scope.row.Result == "Level0" ? '通过' : (scope.row.Result == 'Level4' ? "超频" : '黑名单')  }}
          </span>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="CallerStatus" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.CallerStatus == 'Normal'
                ? 'success'
                : scope.row.CallerStatus == 'IllegalDisable'
                ? 'info'
                : 'warning'
            "
            disable-transitions
            >{{
              scope.row.CallerStatus == "Normal"
                ? "在用"
                : scope.row.CallerStatus == "IllegalDisable"
                ? "违规停机"
                : "管理停机"
            }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="CallerStatus"
        label="号卡状态"
        width="80"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Status ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Status ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column> -->
      <el-table-column align="center" prop="CreationTime" label="过滤时间"></el-table-column>
      <el-table-column align="center" prop="SupplierName" label="所属运营商"></el-table-column>
      <el-table-column align="center" prop="Remark" label="备注"></el-table-column>
    </el-table>
    <el-pagination @size-change="pageSizeChangeHandle1" @current-change="pageCurrentChangeHandle1" :current-page="page"
      :page-sizes="pageSizes" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total"
      style="float: right; margin-top: 15px">
    </el-pagination>
  </section>
</template>

<script>
import viewModule from "@/mixins/view-module";
import moment from "moment";
const CreationTime = moment(new Date()).format("yyyy-MM-DD");
console.log('CreationTime, CreationTimeCreationTimeCreationTimeCreationTimeCreationTime', CreationTime)
import TenantCustomersSelectVue from "@/components/TenantCustomersSelect.vue";
export default {
  mixins: [viewModule],
  components: { TenantCustomersSelectVue },
  data() {
    return {
      dataForm: {
        Caller: "",
        Callee: "",
        CreationTime: CreationTime,
        DepartmentId: "", //组织架构id
        CompanyName: "",//客户公司名称
        MchId: ""
      },
      mixinViewModuleOptions: {
        requestMethod: "post",
        getDataListIsPage: true,
        getDataListURL: "/api/FilterQueryLog/PostAllQueryLogList",
        deleteURL: "",
      },
    };
  },
  methods: {
    pageSizeChangeHandle1(val) {
      this.page = 1
      this.limit = val
      this.handleGetDataList()
    },
    pageCurrentChangeHandle1(val) {
      this.page = val
      this.handleGetDataList()
    },
    handleGetDataList() {
      console.log('handleGetDataList')
      const oldcallee = JSON.parse(JSON.stringify(this.dataForm.Callee));
      const oldcaller = JSON.parse(JSON.stringify(this.dataForm.Caller));
      if (typeof this.dataForm.Callee === 'string') {
        this.dataForm.Callee = this.dataForm.Callee.split("\n").filter((v) => !!v);
      }
      if (typeof this.dataForm.Caller === 'string') {
        this.dataForm.Caller = this.dataForm.Caller.split("\n").filter((v) => !!v);
      }
      this.query();
      this.dataForm.Callee = oldcallee;
      this.dataForm.Caller = oldcaller;
    }
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
